document.addEventListener('turbolinks:load', function (event) {
  if (typeof gtag === 'function') {
    gtag('config', '<%=  Rails.application.credentials.google_analytics %>', {
      'page_location': event.data.url
    })
  }
})
